<template>
  <div class="box">
    <div v-if="visable" class="header-Text">
      <img src="../../assets/images/download/5.png" class="jt">
      <div class="place">请在浏览器中打开</div>
    </div>
    <div class="note">

      <div class="header">
        <div class="sy-cell avterbox">
          <img src="../../assets/images/download/logo.png" class="headerImg">
        </div>
      </div>
      <div class="rule">
        <div class="sy-cell ">
          <img src="../../assets/images/download/1.png">
          下载盖德手环APP
        </div>
        <div class="sy-cell ">
          <img src="../../assets/images/download/2.png">
          获取更详细健康报告
        </div>
        <div class="sy-cell ">
          <img src="../../assets/images/download/3.png">
          每日签到赢取健康币
        </div>
        <div class="sy-cell ">
          <img src="../../assets/images/download/4.png">
          健康商城打折优惠享不停
        </div>
      </div>

      <div class="iphoneX">
        <img src="../../assets/images/download/iphoneX.png">
      </div>
      <div id="footer">
        <button @click="down">下载盖德手环APP</button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      visable: false
    }
  },
  methods: {
    down() {
      const isWeiXin = () => { return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1 }
      if (isWeiXin()) {
        this.visable = true
      } else {
        const u = navigator.userAgent
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
        if (isiOS) {
          window.location.href = 'https://www.pgyer.com/1cs2'
        } else {
          // window.location.href = 'http://api.guiderhealth.com/app/app-user-android.apk'
          window.location.href = ' https://www.pgyer.com/1TyL'
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.box{
  height:auto;
}
.header{
  width:100%;
  height:auto;
  .avterbox{
    display: flex;
    justify-content: center;
    align-items: center;
    // position: fixed;
    width: 100%;
    // padding: 0.4rem 0 0;
    .headerImg{
      width:77px;
      height:77px;
    }
  }
}
.footer{
  margin-top: 10px;
  .van-cell__title{
  display: flex;
  align-items: center;
  .icon2{
  width: 17px;
  height:auto;
  margin-right: 12.5px;
}
}
}

*{
  touch-action: none;
}
.note{
  width: 100%;
}
.rule{
  width: 100%;
  padding-left: 60px;
  font-size: 19px;
  color: #fff;
  .sy-cell{
      margin-bottom:8px;
      font-size:18px;
      white-space: nowrap;
  }
}
.rule img{
  width: 28px;
  height: 28px;
  box-sizing: content-box;
  padding-right: 7px;
}

.iphoneX{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 5px;
}
.iphoneX img{
  width: 170px;
  height:auto;
}

#footer {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-bottom: 21px;
  button {
    box-shadow: 0 8px 16px 0 rgba(0,0,0,0.2), 0 6px 20px 0 rgba(0,0,0,0.19);
    flex: 0 1 auto;
    width: 223px;
    height: 44px;
    color: #373E9A;
    background-color: #fff;
    font-size: 19px;
    padding: 0px;
    border-radius: 55px;
    border: none;
    outline: none;

  }
}
.header-Text{
  width:100%;
  height:100vh;
  background:rgba(0,0,0,0.8);
  font-size: 20px;
  color:#fff;
  text-align: center;
  line-height: 130px;
  position: fixed;
  top: 0;
  .jt{
    width: 38px;
    height: auto;
    float: right;
    margin:20px 40px 10px 30px;
  }
  .place{
    line-height: 130px;
    text-align: right;
  }
}
</style>
<style scoped>
.note{
  min-height:100vh;
  height: auto;
  background:url('../../assets/images/download/dbg.png') no-repeat;
  background-size: cover;
}
</style>

